import {Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import React, {FC} from 'react';

import {CustomSelect, getCustomSelectDefaultPreset} from 'components/form/inputs/custom-select';
import {ILookupValue} from 'shared/types/lookups';

import {EOperationType, IDwhDataPreparationForm} from '../model/dwh-data-preparation-modal.types';

interface IDwhDataPreparationModalFormProps {
    form: FormInstance<IDwhDataPreparationForm>;
    handleFinish: () => void;
    operationType: EOperationType;
    setOperationType: (operationType: EOperationType) => void;
}

export const DwhDataPreparationModalForm: FC<IDwhDataPreparationModalFormProps> = ({
    form,
    handleFinish,
    operationType,
    setOperationType,
}: IDwhDataPreparationModalFormProps) => (
    <Form<IDwhDataPreparationForm>
        form={form}
        layout="vertical"
        onFinish={handleFinish}
    >
        <div
            className="form-flex"
            style={{overflow: 'auto', padding: '8px 12px 8px 0'}}
        >
            <div className="form-flex-row">
                <Form.Item
                    label="Выберите тип операции"
                    name="operationType"
                    required
                    rules={[{required: true}]}
                    initialValue={EOperationType.Protocol}
                >
                    <CustomSelect
                        entries={[
                            {label: 'Получение данных по протоколу операций из DWH', value: EOperationType.Protocol},
                            {label: 'Получение данных по реестру документов из DWH', value: EOperationType.Registry},
                            {
                                label: 'Обогащение реестра документов данными по номеру корректировки декларации',
                                value: EOperationType.Enrichment,
                            },
                        ]}
                        settings={{placeholder: 'Выберите тип операции', isClearable: true}}
                        onChange={(value) => setOperationType(value as EOperationType)}
                        fixedDropdown={false}
                    />
                </Form.Item>
            </div>
            {operationType === EOperationType.Enrichment && (
                <>
                    <div className="form-flex-row">
                        <Form.Item
                            label="Код налога"
                            name="taxCode"
                            required
                            rules={[{required: true}]}
                        >
                            <CustomSelect<string, ILookupValue>
                                settings={{
                                    ...getCustomSelectDefaultPreset('/valueLists/SVC_TAX'),
                                    placeholder: 'Выберите код налога',
                                    isClearable: true,
                                }}
                                sort={{order: 'asc', sortedByValue: 'lookupCode'}}
                                optionsLabelFormatter={(
                                    label,
                                    {lookupCode, description}: Pick<ILookupValue, 'lookupCode' | 'description'>
                                ) => `${lookupCode} - ${description}`}
                                fixedDropdown={false}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Код налогового (отчётного) периода"
                            name="taxPeriod"
                            required
                            rules={[{required: true}]}
                        >
                            <CustomSelect<string, ILookupValue>
                                settings={{
                                    ...getCustomSelectDefaultPreset('/valueLists/SVC2_PERIOD_CODES'),
                                    placeholder: 'Выберите код налогового периода',
                                    isClearable: true,
                                }}
                                sort={{order: 'asc', sortedByValue: 'lookupCode'}}
                                fixedDropdown={false}
                                optionsLabelFormatter={(
                                    label,
                                    {lookupCode, meaning}: Pick<ILookupValue, 'lookupCode' | 'meaning'>
                                ) => `${lookupCode} - ${meaning}`}
                            />
                        </Form.Item>
                    </div>
                    <div className="form-flex-row">
                        <Form.Item
                            label="Код декларации"
                            name="kndCode"
                            required
                            rules={[{required: true}]}
                        >
                            <CustomSelect<string, ILookupValue>
                                sort={{order: 'asc', sortedByValue: 'meaning'}}
                                settings={{
                                    ...getCustomSelectDefaultPreset('/ais/valueLists/KND_DECL_CODES'),
                                    placeholder: 'Выберите код декларации',
                                    isClearable: true,
                                }}
                                fixedDropdown={false}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Отчётный год декларации"
                            name="reportingYear"
                            required
                            rules={[{required: true}]}
                        >
                            <CustomSelect
                                entries={Array(75)
                                    .fill(0)
                                    .map((v, i) => {
                                        const year = 2025 + i;
                                        return {label: year, value: year};
                                    })}
                                settings={{placeholder: 'Выберите отчётный год', isClearable: true, showSearch: true}}
                                fixedDropdown={false}
                            />
                        </Form.Item>
                    </div>
                    <div className="form-flex-row">
                        <Form.Item
                            label="Номер корректировки"
                            name="corrNum"
                            required
                            rules={[{required: true}]}
                        >
                            <Input placeholder="Введите номер корректировки" />
                        </Form.Item>
                    </div>
                </>
            )}
        </div>
    </Form>
);

